import app_img from '@/public/article/App.webp';
import managment_img from '@/public/article/Customer management.webp';
import estimate_img from '@/public/article/Estimate_1.webp';
import invoicing from '@/public/article/Invoice.webp';
import article1 from '@/public/article/picture.webp';
import route_img from '@/public/article/Route Optimization.webp';
import schedule_img from '@/public/article/Schedule_1.webp';
import main_bg from '@/public/industries/appliance/appliance_industry_bg.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'Does your appliance repair business software have a mobile app?',
    text: 'Our software comes with a feature-affluent appliance repair scheduling app. This tool entrusts repairpersons to efficiently handle their work and client details on the move, straight from their mobile gadgets, thereby significantly improving the management of field services.',
  },
  {
    title:
      'What are the benefits of Orcatec appliance repair service management software?',
    text: `Orcatec's appliance repair scheduling software provides a multitude of benefits, including efficient job scheduling, streamlined invoicing, and a centralized system for customer management, all designed to improve service quality and business growth.`,
  },
  {
    title:
      'How can appliance repair service software improve my small business?',
    text: 'Our appliance repair business management software is perfect for small businesses looking to improve their operational workflows. Its features support efficient scheduling, provide detailed customer insights, and help manage inventory, all from one platform.',
  },
];

const testimonals = [
  {
    text: `Since switching to Orcatec, our workflow is seamless, and we're saving hours on schedule.`,
    name: 'Liam S.,',
    position: 'QuickFix Home Appliances',
  },

  {
    text: `As a technician, Orcatec makes my life so much easier. I have all the information I need about each job right at my fingertips, including customer details, repair history, and spare part availability.`,
    name: 'John L.,',
    position: 'Fix-It Fast',
  },
  {
    text: `The comprehensive features in Orcatec ensure that we're always ahead of the competition.`,
    name: 'Sophia T.,',
    position: 'GreenHome Electronics',
  },

  {
    text: `Orcatec has become an essential part of our business. It streamlines every aspect of our operation, from managing customer calls to generating invoices. It's a truly valuable investment for any appliance repair business.`,
    name: 'David M.,',
    position: 'Tech Connect',
  },

  {
    text: `The customizability of Orcatec's platform has been vital for our unique business needs. It's the backbone of our daily operations.`,
    name: 'Noah J.,',
    position: 'HomeTech Solutions',
  },
];

const industries = {
  title: 'Our Top Industries',
  description: `Orcatec offers industry-specific software solutions for a range of service-based businesses. Each software is tailored to meet the unique demands of its respective industry:
  `,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Appliance Repair Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Scheduling appointment',
      },
      href: '#',
      tag: 'Scheduling appointment',
      title: 'Advanced Job Scheduling',
      text: `Elevate the efficiency and visibility of your appliance repair business with Orcatec's bespoke job scheduling. This feature is meticulously designed to streamline the organization of repair appointments and job allocations, promoting optimal resource and time management specifically for the appliance repair sector.`,
      list: [
        {
          text: 'Tailors the organization of repair appointments, virtually eliminating the risk of double-booking.',
        },
        {
          text: 'Enables the seamless coordination of numerous repair jobs, enhancing time efficiency.',
        },
        {
          text: 'Empowers your business to manage schedules more effectively, driving significant gains in productivity.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Customer Relationships Management',
      },
      href: '#',
      tag: 'Customer Relationships Management',
      title: 'Better Service Quality',
      text: `Strengthen your customer connections and elevate service quality with Orcatec's specialized customer management for appliance repair businesses. This tool is invaluable for fostering customer loyalty and gaining a deeper understanding of client needs.`,
      list: [
        {
          text: 'Detailed tracking of all customer interactions, preferences, and service histories, designed with appliance repair services in mind.',
        },
        {
          text: 'Customized attention for each client, boosting satisfaction by addressing the unique needs of appliance repair customers.',
        },
        {
          text: 'Support for nurturing long-term client relationships through superior service quality and personalized experiences.',
        },
      ],
    },

    {
      type: ArticleType.HORIZONTAL,
      image: {
        path: invoicing,
        alt: 'Invoicing and Billing ',
      },
      href: '#',
      tag: 'Invoicing and payments',
      title: 'Streamlined Invoicing',
      text: `Facilitate your financial operations and enhance cash flow management with Orcatec's streamlined invoicing tailored for the appliance repair industry. This feature is critical for sustaining a healthy cash flow and managing finances with greater efficiency.`,

      list: [
        {
          text: 'Reduces the manual effort in creating and sending invoices from job completion to payment.',
        },
        {
          text: 'Assists in monitoring payments and effectively managing accounts receivable.',
        },
        {
          text: 'Decreases the time and resources spent on billing, leading to smoother financial operations.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: route_img,
        alt: 'Workflow dispatching',
      },
      href: '#',
      tag: 'Workflow dispatching',
      title: 'Intelligent Dispatch',
      text: `Optimize field operations and increase efficiency with Orcatec's intelligent dispatch. It's essential for maximizing field staff productivity and offering timely services.`,
      list: [
        {
          text: 'GPS tracking for immediate deployment and scheduling adjustments tailored for appliance repair technicians.',
        },
        {
          text: 'Reduced technician downtime, leading to improved utilization of resources.',
        },
        {
          text: 'Boosted service team productivity by ensuring efficient staff allocation, specifically designed for the appliance repair industry.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: estimate_img,
        alt: 'Estimates',
      },
      href: '#',
      tag: 'Estimates',
      title: 'Maximize Revenue',
      text: `Provide detailed proposals with multiple options that align with clients' budgets using the Good, Better, Best model. This approach not only increases your average job revenue but also encourages customers to opt for premium services.`,
      list: [
        {
          text: 'Create and track your estimates. Get instant notification when client opens your estimate.',
        },
        {
          text: 'Attach files and documents to your estimates, tailored specifically for appliance repair software scenarios.',
        },
        {
          text: 'Send your estimates by email, text, link copy and paste or PDF downloads.',
        },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Appliance Repair Business Software',
  title: {
    first_part: 'Transform Your Appliance Repair Business with',
    second_part: 'Orcatec',
  },
  description: `Orcatec's appliance repair service business software is designed to help appliance service technicians achieve maximum efficiency and profitability. Our platform simplifies every facet of your daily operations from job scheduling to streamlined dispatch, and a robust CRM system for maintaining long-term customer relationships.`,
  info: [
    { title: '50%', description: 'Enhanced Technician Utilization' },
    { title: '35%', description: 'Quicker Invoice Turnaround' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1,
    alt: 'What Is Appliance Repair Business Software?',
  },
  title: 'What Is Appliance Repair Business Software?',
  description: `Appliance repair business software is a sophisticated solution that facilitates the management of service requests, client communication, and back-office operations for appliance repair companies. It acts as a central hub for various aspects of the appliance repair industry.`,
  item: [
    {
      title: 'Scheduling Appointment',
      description: 'Ensures efficient tracking and management of appointments.',
    },
    {
      title: 'Dispatch Workflow',
      description:
        'Assign tasks to technicians, track job progress, manage inventory of spare parts, and optimize scheduling for improved efficiency.',
    },
    {
      title: 'Customer Information Within Mobile App',
      description:
        'Allows field technicians to create and utilize custom data entry forms for data collection about the issue and appliance, such as problem description, model, serial number, etc.',
    },
    {
      title: 'Invoicing & Payments',
      description:
        'Generate detailed proposals with various repair options for different budgets.',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why Appliance Repair Contractors Choosing Orcatec?',
  },
  title: 'Why Appliance Repair Contractors Choosing Orcatec?',
  description: `Appliance Repair Contractors are increasingly choosing Orcatec for several compelling reasons, especially considering its range of user-centric advantages:`,
  item: [
    {
      title: '',
      description:
        'Provides a cost-free initial offering, allowing contractors to try out the system without financial commitment.',
    },
    {
      title: '',
      description:
        'Offers customizable payment options where users can selectively choose and pay only for the features they actually need.',
    },
    {
      title: '',
      description: `The system can be easily tailored to meet specific business requirements, ensuring a personalized user experience.`,
    },
    {
      title: '',
      description: `Ensures seamless access across various devices, including PCs, tablets, and mobile phones, enhancing convenience.`,
    },

    {
      title: '',
      description: `Supports a wide range of operating systems, including both iOS and Android, ensuring broad usability regardless of device preference.`,
    },
    {
      title: '',
      description: `The system's efficient job tracking and communication tools aid in forging stronger client bonds by maintaining and enhancing customer relationships.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Dive into our informative blog articles, where we explore various aspects of business management and industry insights, offering valuable knowledge to help you stay ahead in the dynamic world of plumbing and contracting. Discover tips, trends, and strategic advice tailored to enhance your business operations and growth.`,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `Let us guide you to experience in appliance repair management software! Orcatec team is here to help you. Our experts are ready to amplify your operational efficiency.`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
